var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".search-colour{fill:none;stroke:#f19a3e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")),React.createElement("g",{"id":"bc23aa01-8890-4cde-a6b1-93e872ae64e2","data-name":"Icon feather-search","key":1},[React.createElement("path",{"id":"e3ccef28-c815-42c8-947c-f0cb3451dacb","data-name":"Path 304","className":"search-colour","d":"M20,10.5A9.5,9.5,0,1,1,10.5,1,9.5,9.5,0,0,1,20,10.5Z","key":0}),React.createElement("path",{"id":"a080cd4b-70e4-46fa-b982-3ff1ddfbed93","data-name":"Path 305","className":"search-colour","d":"M22.371,22.371l-5.165-5.165","key":1})])]);
}

SearchIcon.defaultProps = {"id":"aed7050b-1acb-4bcd-9e66-0042ead194f0","data-name":"Layer 1","viewBox":"0 0 23.371 23.371"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
